import { BLUE_DARK } from "../styles/mui-theme";

export const homePaceComponentStyle = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
  marginBottom: "0px",
};

export const gridContainerStyle = {
  width: { xs: "100%", sm: "80%", md: "70%", lg: "50%" },
};

export const fullWidthGridStyle = {
  width: { xs: "100%", sm: "95%", md: "95%", lg: "90%" },
};

export const paperBoxStyle = {
  bgcolor: "common.white",
  boxShadow: { xs: 0, sm: 4 },
  display: "flex",
  flexDirection: "column",
  overflowX: "clip",
  // A definite cross size, so the shell cannot be sized by its widest descendant.
  //
  // This box is a flex item in a column flex container, which means its width is resolved from
  // content unless it is told otherwise — and `overflow-x: clip` does not make it a scroll
  // container, so it does not zero that contribution either. The horizontally scrolling row of
  // filter chips was enough to stretch the whole page to 1297px on a 375px screen: the row could
  // never scroll, because everything above it had already grown to fit it.
  width: "100%",
  minWidth: 0,
};

export const footerContainerStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
};

export const footerBoxStyle = {
  p: 2,
  mx: 0.5,
  bgcolor: BLUE_DARK,
  color: "white",
  display: "flex",
  gap: 2,
  justifyContent: "space-around",
  alignItems: "center",
  width: { xs: "100%", sm: "50%", md: "50%", lg: "50%" },
  boxShadow: "0 0 10px 1px rgba(0,255,128,0.6)",
  borderRadius: "10px",
};
